import React from 'react';
import axios from 'axios'
import { Table, Input, Button,Collapse,Popover,Popconfirm,message,Spin,Tabs } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon from '@ant-design/icons';
import { SearchOutlined,DeleteOutlined,FundViewOutlined,LoadingOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import * as serverconfig from '../serverconn'
import ApplicantActions from './ApplicantActions';
import ActionLogs from './ActionLogs';
import ActionStatuses_ForApplication from './ActionStatuses_ForApplication';
import LoanApplicationDetails from './LoanApplicationDetails';
import SpartialData from './SpartialData';

var CryptoJS = require("crypto-js");

const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

function callback(key) {
  console.log(key);
}
const { TabPane } = Tabs;

var token= ''
var bizuserid= ''

class LicenceApplications extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    applications: [],
    datarequested:true,

    action_statuses:[],
    action_logs:[],
    applicant_actions:[],
    application_files:[]

  };

  componentDidMount(){
    this.comp_reloaded()
    
}

comp_reloaded=()=>{

  if(localStorage.getItem("token")){
     token= localStorage.getItem("token")
  }else{
     token= ''
  }

  if(localStorage.getItem("bizuserid")){
    bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
 }else{
    bizuserid= ''
 }

  axios.defaults.headers={
    "Content-Type":"application/json",
    Authorization:`Token ${token}`
  }

  axios.get(serverconfig.backendserverurl+`/api/applications/`)
  .then(res => {
      this.setState({
          applications:res.data
      })
      this.setState({datarequested:false})
  })



}



getColumnSearchProps = dataIndex => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Input
        ref={node => {
          this.searchInput = node;
        }}
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
      />
      <Button
        type="primary"
        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        icon={<SearchOutlined />}
        size="small"
        style={{ width: 90, marginRight: 8 }}
      >
        Search
      </Button>
      <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
        Reset
      </Button>
    </div>
  ),
  filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
  onFilter: (value, record) =>
    record[dataIndex]
      .toString()
      .toLowerCase()
      .includes(value.toLowerCase()),
  onFilterDropdownVisibleChange: visible => {
    if (visible) {
      setTimeout(() => this.searchInput.select());
    }
  },
  render: text =>
    this.state.searchedColumn === dataIndex ? (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ) : (
      text
    ),
});

handleSearch = (selectedKeys, confirm, dataIndex) => {
  confirm();
  this.setState({
    searchText: selectedKeys[0],
    searchedColumn: dataIndex,
  });
};

handleReset = clearFilters => {
  clearFilters();
  this.setState({ searchText: '' });
};



  render() {

    const columns = [
     
      {
        title: 'Date',
        dataIndex: 'submitted_at',
        key: 'id',
        ...this.getColumnSearchProps('submitted_at'),
      },
      {
        title: 'Licence Category',
        dataIndex: 'licence_type_name',
        key: 'id',
      },

      {
        title: 'Category Grouping',
        dataIndex: 'licence_type_licence_type',
        key: 'id',
      },
      {
        title: 'Application ID',
        dataIndex: 'application_id',
        key: 'id',
      },
      {
        title: 'Applicant',
        dataIndex: 'applicant_name',
        key: 'id',
      },
      {
        title: 'Service',
        dataIndex: 'workflow_name',
        key: 'id',
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'id',
      },
     

    ];
    

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin size="large">
                <div className="content" />
              </Spin>      
         </div>
      )

    }else{
      return(
        <div>

              <h4>There are {this.state.applications.length} Applications</h4>
                <Table 
                columns={columns} 
                scroll={{ x: 1000 }}
                pagination={{showQuickJumper:true,showSizeChanger:true }}
                dataSource={this.state.applications}
                bordered

                expandable={{
                  expandedRowRender: (record) =>{
                      return (
                        <div>
                       <Tabs
                          defaultActiveKey="1"
                          onChange={() => {}}
                          tabPosition={'top'}
                        >
                          <TabPane tab={"Application details"} key="1">
                            
                            <LoanApplicationDetails 
                            application_record={record}
                            application_files={this.state.application_files} />

                          </TabPane>

                          {
                          record.licence_type_licence_type==="Spartial"?
                          <TabPane tab={"Shapes"} key="5">
                            <SpartialData 
                            application_id={record.id}
                            />
                          </TabPane>:null}


                          <TabPane tab={"Applicant Actions ("+this.state.applicant_actions.length+")"} key="2">
                            <ApplicantActions applicant_actions={this.state.applicant_actions} />
                          </TabPane>

                          <TabPane tab={"Action Logs ("+this.state.action_logs.length+")"} key="3">
                            <ActionLogs action_logs={this.state.action_logs}  />
                          </TabPane>

                          <TabPane tab={"Action Status ("+this.state.action_statuses.length+")"} key="4">
                            <ActionStatuses_ForApplication action_statuses={this.state.action_statuses} />
                          </TabPane>

                        </Tabs>

                        </div>
                      );
                  } ,
                  rowExpandable: (record) => true,
                  onExpand:(condition,record)=>{

                    axios.get(serverconfig.backendserverurl+`/api/action_statuses/?application=${record.id}`)
                    .then(res => {
                        this.setState({
                          action_statuses:res.data
                        })
                  
                    })


                    axios.get(serverconfig.backendserverurl+`/api/action_logs/?application=${record.id}`)
                    .then(res => {
                        this.setState({
                          action_logs:res.data
                        })
                  
                    })

                    axios.get(serverconfig.backendserverurl+`/api/applicant_actions/?application=${record.id}`)
                    .then(res => {
                        this.setState({
                          applicant_actions:res.data
                        })
                  
                    })


                    axios.get(serverconfig.backendserverurl+`/api/application_files/?application=${record.id}`)
                    .then(res => {
                        this.setState({
                          application_files:res.data
                        })
                    })

                  },
                }}
                
                />

        </div>
    )

    }

   
  }
}

export default LicenceApplications; 
